import MatchPwned from './matching';
import scoring from './scoring';
import FeedbackFactory from './feedback';
import haveIBeenPwned from './haveIBeenPwned';
export const matcherPwnedFactory = (universalFetch, options, config = {}) => {
    return {
        Matching: MatchPwned(universalFetch, config),
        feedback: FeedbackFactory(options),
        scoring,
    };
};
export { haveIBeenPwned };
//# sourceMappingURL=index.js.map